import React from 'react';
import PropTypes from 'prop-types';

class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.handleKeyUp = this.handleKeyUp.bind(this);
  }

  handleKeyUp(e) {
    e.preventDefault();
    if (this.props.noclose) {
      return;
    }
    if (e.keyCode === 27) {
      this.props.toggleModal(null);
    }
  }

  componentDidMount() {
    window.addEventListener('keyup', this.handleKeyUp, false);
  }

  componentWillUnmount() {
    window.removeEventListener('keyup', this.handleKeyUp, false);
  }

  render() {
    const { noclose, sideBar, darkModal, wideModal } = this.props;

    let modalClass = 'modal';

    if (sideBar) {
      modalClass = modalClass + ' sb-modal';
    }

    if (wideModal) {
      modalClass = modalClass + ' wide-modal';
    }

    return (
      <div className={darkModal ? 'modal-container dark-modal' : 'modal-container'}>
        { noclose ?
          <div className="backdrop" />
          :
          <div className="backdrop" onClick={() => this.props.toggleModal(null)} />
        }
        <div className="modal-table">
          <div className="modal-aligner">
            <div className={modalClass}>
              { noclose ?
                null
                : (
                <div className="modal-close" onClick={() => this.props.toggleModal(null)}>
                  {darkModal ? (
                    <img alt="close" src={ process.env.REACT_APP_CDN + '/assets/icons/close-w.svg'} />

                  ) : (
                    <img alt="close" src={ process.env.REACT_APP_CDN + '/assets/icons/close.svg'} />
                  )}
                </div>
              )}
              {this.props.modalComponent}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Modal.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  show: PropTypes.bool,
  children: PropTypes.node,
};

export default Modal;
